import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEdit,
  faTrash,
  faArrowsAlt,
  faPlus,
  faMinus,
  faPowerOff,
  faLock,
  faTimesCircle,
  faDownload,
  faQuestion,
  faPen,
  faEye,
  faExclamationCircle,
  faCheck,
  faInfoCircle,
  faQuestionCircle,
  faList,
  faSortAmountDown,
  faExternalLinkAlt,
  faCircle,
  faExclamation,
  faTimes,
  faHourglassHalf
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(
  faEdit,
  faTrash,
  faArrowsAlt,
  faPlus,
  faMinus,
  faPowerOff,
  faLock,
  faTimesCircle,
  faDownload,
  faQuestion,
  faPen,
  faEye,
  faExclamationCircle,
  faCheck,
  faInfoCircle,
  faList,
  faSortAmountDown,
  faQuestionCircle,
  faExternalLinkAlt,
  faCircle,
  faExclamation,
  faTimes,
  faHourglassHalf
)

export { FontAwesomeIcon as default, library }
